import React from 'react';
import styled from 'styled-components';
import { Link } from '../svg';
import { Tooltip } from '@mui/material';
import Button from '../../../../FlyfishComponents/Button';

const TextDIV = styled.div<{ index: number; type: string }>`
	cursor: pointer;
	min-width: 318px;
	max-width: 318px;
	padding: 20px;
	background: ${(props) =>
		props.type === 'sources'
			? '#DDDDDD2E'
			: props.index === 0
			? 'transparent linear-gradient(106deg, #efefef2E 0%, #ff4d842E 100%)'
			: props.index === 1
			? 'transparent linear-gradient(280deg, #B046F22E 0%, #EDEDED2E 100%)'
			: 'transparent linear-gradient(108deg, #F0F0F02E 0%, #B0E38A2E 100%)'};
	border: 1px solid #7070702e;
	border-radius: 11px;
	& > .text {
		opacity: 1;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: normal;
		font-weight: 600;
	}
	& > .sources {
		display: flex;
		align-items: center;
		justify-content: space-between;
		& > .text {
			display: -webkit-box;
			-webkit-line-clamp: 1;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: normal;
			font-weight: 600;
			width: 225px;
		}
	}
`;
type Props = {
	text: string;
	index: number;
	type?: string;
	redirectURL?: string;
	handleSubmit?: Function;
	addUserResponse?: Function;
};
const TextCards = ({
	text,
	index,
	type = '',
	redirectURL = '',
	handleSubmit,
}: Props) => {
	return (
		<TextDIV
			index={index}
			type={type}
			onClick={() => {
				if (type === 'sources') {
					window.open(redirectURL);
				} else {
					handleSubmit(text);
				}
			}}
		>
			{type === 'sources' ? (
				<div className={type}>
					<Tooltip title={text}>
						<div className='text'>{text}</div>
					</Tooltip>
					<div className='link'>
						<Link />
					</div>
				</div>
			) : (
				<>
					<Tooltip title={text}>
						<div className='text'>{text}</div>
					</Tooltip>
				</>
			)}
		</TextDIV>
	);
};

export default TextCards;
